import { Pipe, PipeTransform } from '@angular/core';
import {
  EquipmentGeneralTypes,
  TERMINAL_TYPES_CLIMATE,
  TERMINAL_TYPES_CONFIGURABLE,
  TERMINAL_TYPES_DATALOGGER,
  TERMINAL_TYPES_IRRIGATION,
} from '@nutricontrol/app360-shared';

@Pipe({
  name: 'terminalTypeName',
})
export class TerminalTypeNamePipe implements PipeTransform {
  transform(
    type: number
  ): 'IRRIGATION' | 'CLIMATE' | 'DATALOGGER' | 'CONFIGURABLE' | 'UNKNOWN' {
    let str_type = '';

    if (TERMINAL_TYPES_IRRIGATION.includes(type)) {
      str_type = EquipmentGeneralTypes.irrigation;
    } else if (TERMINAL_TYPES_CLIMATE.includes(type)) {
      str_type = EquipmentGeneralTypes.climate;
    } else if (TERMINAL_TYPES_DATALOGGER.includes(type)) {
      str_type = EquipmentGeneralTypes.datalogger;
    } else if (TERMINAL_TYPES_CONFIGURABLE.includes(type)) {
      str_type = EquipmentGeneralTypes.configurable;
    } else {
      str_type = EquipmentGeneralTypes.unknown;
    }

    return str_type.toUpperCase() as
      | 'IRRIGATION'
      | 'CLIMATE'
      | 'DATALOGGER'
      | 'CONFIGURABLE'
      | 'UNKNOWN';
  }
}
